import {useState, useEffect} from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Loading from '../../common/Loading';

export default function LoadListFilterLengthOperatorList(props) {
    //console.debug("RTS Break LoadListFilterLengthOperatorList");

    const [isLoading, setIsLoading] = useState(true);

    const [lengthOperator, setLengthOperator] = useState();


    useEffect(() => {
        if(props.lengthOperator===null){
            setLengthOperator(">=");
        }
        else{
            setLengthOperator(props.lengthOperator);
        }

        setIsLoading(false);
    }, [props]); 


    function valChange(e){
        props.setLengthOperatorFx(e.target.value);
        setLengthOperator(e.target.value);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <FormControl size="small" sx={{ m: 0, minWidth: 70 }}>
                <Select
                    labelId=""
                     id="lengthOperator"
                    value={lengthOperator}
                    onChange={valChange}
                    label="Operator"
                >
                    <MenuItem value={">="}>&gt;=</MenuItem>
                    <MenuItem value={"<="}>&lt;=</MenuItem>
                </Select>
            </FormControl>


        </>
    );
}

